export const edPortalTerms = {
  ein: `Your Educator Identification Number is a unique number assigned to you within the Arizona Department of Education.`,
  fingerprintValidity: `Your current IVP Fingerprint Card Status as far as the Arizona Department of Education is aware.`,
};
